<template>
    <footer class="row mt-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-8 offset-2">
                    <div class="row">
                        <div class="col-12 col-xl-6 text-center">
                            <router-link :to="{name: 'ProvisionComponent'}">Điều khoản</router-link> |
                            <router-link :to="{name: 'SecurityComponent'}">Bảo mật</router-link>
                        </div>
                        <div class="col-12 col-xl-6 text-center">
                            <div class="copyright">
                                <p>Copyright © 2020</p>
                                <p>THIEN THUONG HOA ENTERTAINMENT JOINT STOCK COMPANY</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "FooterComponent"
    }
</script>

<style scoped>

</style>
